import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const UploadFileIconSvg = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1126_2260)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.5V9C12 9.37288 12.1389 9.73239 12.3896 10.0084C12.6403 10.2844 12.9848 10.4572 13.356 10.493L13.5 10.5H20V20.5C20.0002 21.0046 19.8096 21.4906 19.4665 21.8605C19.1234 22.2305 18.6532 22.4572 18.15 22.495L18 22.5H6C5.49542 22.5002 5.00943 22.3096 4.63945 21.9665C4.26947 21.6234 4.04284 21.1532 4.005 20.65L4 20.5V4.5C3.99984 3.99542 4.19041 3.50943 4.5335 3.13945C4.87659 2.76947 5.34684 2.54284 5.85 2.505L6 2.5H12ZM11.293 11.673L9.172 13.794C9.07649 13.8862 9.00031 13.9966 8.9479 14.1186C8.89549 14.2406 8.8679 14.3718 8.86675 14.5046C8.8656 14.6374 8.8909 14.7691 8.94118 14.892C8.99146 15.0149 9.06571 15.1265 9.15961 15.2204C9.2535 15.3143 9.36515 15.3885 9.48805 15.4388C9.61094 15.4891 9.74262 15.5144 9.8754 15.5133C10.0082 15.5121 10.1394 15.4845 10.2614 15.4321C10.3834 15.3797 10.4938 15.3035 10.586 15.208L11 14.794V17.5C11 17.7652 11.1054 18.0196 11.2929 18.2071C11.4804 18.3946 11.7348 18.5 12 18.5C12.2652 18.5 12.5196 18.3946 12.7071 18.2071C12.8946 18.0196 13 17.7652 13 17.5V14.794L13.414 15.208C13.5062 15.3035 13.6166 15.3797 13.7386 15.4321C13.8606 15.4845 13.9918 15.5121 14.1246 15.5133C14.2574 15.5144 14.3891 15.4891 14.512 15.4388C14.6349 15.3885 14.7465 15.3143 14.8404 15.2204C14.9343 15.1265 15.0085 15.0149 15.0588 14.892C15.1091 14.7691 15.1344 14.6374 15.1333 14.5046C15.1321 14.3718 15.1045 14.2406 15.0521 14.1186C14.9997 13.9966 14.9235 13.8862 14.828 13.794L12.708 11.673C12.6151 11.58 12.5048 11.5063 12.3834 11.4559C12.262 11.4056 12.1319 11.3797 12.0005 11.3797C11.8691 11.3797 11.739 11.4056 11.6176 11.4559C11.4962 11.5063 11.3859 11.58 11.293 11.673ZM14 2.543C14.3234 2.61165 14.6247 2.75939 14.877 2.973L15 3.086L19.414 7.5C19.6483 7.73411 19.8208 8.02275 19.916 8.34L19.956 8.5H14V2.543Z"
        fill="#9747FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1126_2260">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const UploadFileIcon: FC<Partial<CustomIconComponentProps>> = (
  props
) => <Icon component={UploadFileIconSvg} {...props} />;

export default UploadFileIcon;

UploadFileIcon.displayName = "UploadFileIcon";
